export const DeactivateSvg = () => {
  return (
    <svg
      width={"20"}
      height={"20"}
      viewBox={"0 0 20 20"}
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}>
      <path
        d={
          "M9.99984 18.3332C5.39746 18.3332 1.6665 14.6022 1.6665 9.99984C1.6665 5.39746 5.39746 1.6665 9.99984 1.6665C14.6022 1.6665 18.3332 5.39746 18.3332 9.99984C18.3332 14.6022 14.6022 18.3332 9.99984 18.3332ZM9.99984 16.6665C13.6818 16.6665 16.6665 13.6818 16.6665 9.99984C16.6665 6.31794 13.6818 3.33317 9.99984 3.33317C6.31794 3.33317 3.33317 6.31794 3.33317 9.99984C3.33317 13.6818 6.31794 16.6665 9.99984 16.6665ZM5.83317 9.1665H14.1665V10.8332H5.83317V9.1665Z"
        }
        fill={"currentColor"}
      />
    </svg>
  );
};
